// lets a page put its own message in the global Footer's left slot (in place
// of GlobalPagination), the same way tables drive GlobalPagination via
// state.pagination — see Footer.js
export function setFooterLeftOverride(override) {
	return {
		type: "SET_FOOTER_LEFT_OVERRIDE",
		payload: override,
	};
}

export function clearFooterLeftOverride() {
	return {
		type: "SET_FOOTER_LEFT_OVERRIDE",
		payload: null,
	};
}
